export default "__VITE_ASSET__Dn1eH9o5__"